/* eslint-disable no-unused-vars */
import { CareerAndSeasonStatsState } from './career-and-season-stats/types';
import { StatsLeadersState } from './stats-leaders/types';
import { StatComparisonState } from './stat-comparison/types';
import { PerformanceChartState } from './performance-chart/types';
import './season-leaders/reducer/types';
import './last-round-highs/reducer/types';
import './featured-head-to-head/reducer/types';

/**
 * @typedef {object} StatsState
 * @property {StatsLeadersState} statsLeaders
 * @property {CareerAndSeasonStatsState} careerAndSeasonStats
 * @property {object} glossary
 * @property {SeasonLeadersState} seasonLeaders
 * @property {LastRoundHighsState} lastRoundHighs
 * @property {PerformanceChartState} performanceChart
 * @property {StatComparisonState} statComparison
 * @property {FeaturedHeadToHeadState} featuredHeadToHead
 */

/**
 * @typedef {'seasons'|'rounds'} StatsLeadersStatsType
 * @typedef {'round'|'season'} LastRoundHighsStatsType
 */
